module.exports = __webpack_public_path__ + "static/media/shop02.0457027a.png";